export function listCour() {
    let array = [{
        video_id: 0,
        url: null,
    }];
    return array;
}


// WEBPACK FOOTER //
// ./src/controller/videoCours.js